export default __webpack_public_path__ + "static/media/Slide11.65e76246.JPG";